import React from "react";
import { Link } from "react-router-dom";
import { LandingNav } from "./LandingPage";
import { CheckCircle } from "lucide-react";

/**
 * Shown after user clicks the unsubscribe link in a marketing email.
 * Content is always in English as requested for the unsubscribe flow.
 */
export default function UnsubscribeSuccess() {
  return (
    <main className="min-h-screen text-white relative">
      <div className="fixed inset-0 bg-gradient-to-br from-purple-950 via-slate-950 to-black pointer-events-none -z-10" />
      <div className="fixed inset-0 bg-gradient-to-tr from-transparent via-purple-900/20 to-transparent pointer-events-none -z-10" />

      <LandingNav />

      <section className="relative overflow-hidden py-20 md:py-28">
        <div className="relative mx-auto max-w-lg px-4 text-center">
          <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-500/20 text-emerald-400">
            <CheckCircle size={40} />
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-white mb-3">
            You have successfully unsubscribed
          </h1>
          <p className="text-slate-400 mb-8 md:text-lg">
            You will no longer receive marketing emails from Invoitio. You can
            still use your account and receive important account-related
            messages.
          </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center h-12 px-6 md:px-8 rounded-xl text-white font-semibold bg-pink-600 hover:bg-pink-500 hover:shadow-pink-500/30 border-0 transition-colors"
          >
            Back to Invoitio
          </Link>
        </div>
      </section>
    </main>
  );
}
